<template lang="pug">
  div.text-center
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20"
      )
        p.text-center Clique sobre o botão correspondente ao perfil que deseja acessar o sistema:
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20",
        v-if="usuario"
      )
        el-col(:xs="24", :sm="12", :md="8", :lg="6", :xl="4",
                v-for ="perfil in [...perfis].sort((a, b) => (a.nome > b.nome) ? 1 : -1)",
                :key="perfil.id"
              )
          .card(@click="setPerfilUsuario(perfil)")
            el-card
              div(slot="header")
                img.perfil(:src="imgPerfil(perfil)")
              div
                span {{ perfil.nome }}
      el-button.button(type="default" @click="sair")
        span.center
          i.fas.fa-chevron-left
          span &nbsp Voltar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rotas from '@/constants/rotas'
import MainHeader from '@/components/MainHeader'

export default {
  components: {
    MainHeader
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  },

  data () {
    return {
      perfis: []
    }
  },

  async created () {
    this.perfis = await this.findPerfisUsuario({ idUsuario: this.usuario.id, idModulo: this.usuario.moduloSelecionado.id })
  },

  methods: {
    ...mapActions({
      getToken: 'auth/getToken',
      selecionePerfil: 'auth/selecionePerfil',
      findPerfisUsuario: 'usuario/findPerfisUsuario'
    }),

    async setPerfilUsuario (perfil) {
      await this.selecionePerfil({ moduloId: this.usuario.moduloSelecionado.id, perfilId: perfil.id })
      const token = await this.getToken()
      const tokenFormatado = process.env.NODE_ENV === 'development' ? `?token=${token}` : ''
      if (rotas.EXTERNAS.includes(this.usuario.perfilSelecionado.modulo)) {
        if (this.perfis[0].modulo === 'GESTAO_PRAZOS') {
          window.location.href = process.env.URL_GESTAO_PRAZOS
          return
        } else if (this.perfis[0].modulo === 'CREDENCIADOS' || (this.isBahia && this.perfis[0].modulo === 'GESTAO_DE_CREDENCIADOS')) {
          window.location.href = process.env.URL_CREDENCIADOS
          return
        } else if (this.perfis[0].modulo === 'REURB') {
          window.location.href = process.env.URL_REURB_WEB + tokenFormatado
          return
        } else if (this.perfis[0].modulo === 'VISTORIA') {
          window.location.href = process.env.URL_VISTORIA
          return
        }

        const token = await this.getToken()
        window.location.href = this.usuario.perfilSelecionado.paginaInicial + token
        return
      }

      this.$router.push({
        name: this.usuario.perfilSelecionado.paginaInicial
      })
    },

    async sair () {
      if (this.$route.name === 'selecionarModulo') {
        this.$router.push({ name: 'logout' })
      } else if (this.$route.name === 'selecionarPerfil' || this.perfis.length === 1) {
        this.$router.push({ name: 'selecionarModulo' })
      } else {
        this.$router.push({ name: 'selecionarPerfil' })
      }
    },

    imgPerfil (perfil) {
      return 'static/perfis/' + perfil.icone
    }
  }
}
</script>

<style lang="scss" scoped>

  .text-center {
    text-align: center;
  }

  .button {
    margin: 20px;
  }

  .container {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    * {
      flex-wrap: wrap;
    }
  }

  .card {
    margin-bottom: 10px;
    flex-wrap: wrap;
    cursor: pointer;
    > :hover{
      transform: scale(1.05);
      transition-property: 2s;
    }
  }

  .perfil {
    width: 180px;
    height: 180px;
  }

  @media (max-width: 780px) {

  .back {
    background-color: aqua;
  }

}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/SelecionarPerfil.vue